/* tslint:disable */
/* eslint-disable */
export enum WorkTaxTypeEnum {
  Input = 'input',
  Output = 'output'
}
